import { useDispatch, useSelector } from 'stores'
import { Alert } from '@types'
import {
  fetchAlert,
  clear as clearStore,
  initialState,
} from '../stores/alert.store'

export function useAlert() {
  const dispatch = useDispatch()
  const notification = useSelector((state) => state.notification)

  function open(config: Alert) {
    return dispatch(
      fetchAlert(Promise.resolve({ ...initialState.data, ...config }))
    )
  }

  function clear() {
    dispatch(clearStore())
  }

  return { alert: notification.alert, open, clear }
}
